import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";
import { PromoMasterSelectedSlicerModel } from "../../models/TradeAndPromoPlanning/PromoMasterSlicer.model";
import PromoMasterTabSlice from "../../models/Redux/PromoMasterTabSlice.model";
import { PROMO_MASTER_TAB_ID } from "../../shared/constants";

const defaultSlicers: PromoMasterSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(PROMO_MASTER_TAB_ID);

const initialState: PromoMasterTabSlice = {
  tempSelectedSlicers: defaultSlicers,
  selectedSlicers: defaultSlicers,
  slicers: {
    skus: [],
  },
  dropdownSlicers: {
    skus: [],
  }
};

const promoMasterTabSlice: Slice = createSlice({
  name: "promoMasterTab",
  initialState,
  reducers: {
    setSlicers: (state, action) => {
      state.slicers = action.payload;
    },
    setDropdownSlicers: (state, action) => {
      state.dropdownSlicers = action.payload;
    },
    setTempSelectedSlicers: (
      state,
      action: { payload: PromoMasterSelectedSlicerModel }
    ) => {
      state.tempSelectedSlicers = action.payload;
    },
    setSelectedSlicers: (state, action) => {
      state.selectedSlicers = action.payload;
    },
    resetSelectedSlicers: (state, action) => {
      state.tempSelectedSlicers = structuredClone(defaultSlicers);
      state.selectedSlicers = structuredClone(defaultSlicers);
    }
  },
});

export const promoMasterTabActions = promoMasterTabSlice.actions;

export default promoMasterTabSlice.reducer as Reducer<PromoMasterTabSlice>;
